import GopersonalAutoService from '../../services/gopersonalAuto'

export const state = {}
export const mutations = {}
export const getters = {}

const call = (fn) => (...args) =>
	new Promise((resolve, reject) => {
		fn(...args).then((response) => resolve(response.data)).catch((error) => reject(error))
	})

export const actions = {
	// eslint-disable-next-line no-unused-vars
	init({ state, dispatch }) {},

	// eslint-disable-next-line no-unused-vars
	getAutoGoals({ commit }, payload) { return call(GopersonalAutoService.getGoals)(payload) },
	// eslint-disable-next-line no-unused-vars
	getAutoGoal({ commit }, goalId) { return call(GopersonalAutoService.getGoal)(goalId) },
	// eslint-disable-next-line no-unused-vars
	createAutoGoal({ commit }, goal) { return call(GopersonalAutoService.createGoal)(goal) },
	// eslint-disable-next-line no-unused-vars
	updateAutoGoal({ commit }, goal) { return call(GopersonalAutoService.updateGoal)(goal) },
	// eslint-disable-next-line no-unused-vars
	deleteAutoGoal({ commit }, goalId) { return call(GopersonalAutoService.deleteGoal)(goalId) },
	// eslint-disable-next-line no-unused-vars
	runAutoGoal({ commit }, goalId) { return call(GopersonalAutoService.runGoal)(goalId) },
	// eslint-disable-next-line no-unused-vars
	pauseAutoGoal({ commit }, goalId) { return call(GopersonalAutoService.pauseGoal)(goalId) },
	// eslint-disable-next-line no-unused-vars
	resumeAutoGoal({ commit }, goalId) { return call(GopersonalAutoService.resumeGoal)(goalId) },
	// eslint-disable-next-line no-unused-vars
	getAutoGoalMetrics({ commit }, { goalId, ...params }) { return call(GopersonalAutoService.getGoalMetrics)(goalId, params) },
	// eslint-disable-next-line no-unused-vars
	getAutoGoalSummary({ commit }, goalId) { return call(GopersonalAutoService.getGoalSummary)(goalId) },
	// eslint-disable-next-line no-unused-vars
	getAutoGoalLimits({ commit }) { return call(GopersonalAutoService.getGoalLimits)() },
	// eslint-disable-next-line no-unused-vars
	getAutoRuns({ commit }, payload) { return call(GopersonalAutoService.getRuns)(payload) },
	// eslint-disable-next-line no-unused-vars
	getAutoRun({ commit }, runId) { return call(GopersonalAutoService.getRun)(runId) },
	// eslint-disable-next-line no-unused-vars
	cancelAutoRun({ commit }, { runId, reason }) { return call(GopersonalAutoService.cancelRun)(runId, reason) },
	// eslint-disable-next-line no-unused-vars
	getAutoProposals({ commit }, payload) { return call(GopersonalAutoService.getProposals)(payload) },
	// eslint-disable-next-line no-unused-vars
	approveAutoProposal({ commit }, { proposalId, comment }) { return call(GopersonalAutoService.approveProposal)(proposalId, comment) },
	markDoneAutoProposal(ctx, { proposalId, comment }) { return call(GopersonalAutoService.markDoneProposal)(proposalId, comment) },
	// eslint-disable-next-line no-unused-vars
	rejectAutoProposal({ commit }, { proposalId, comment }) { return call(GopersonalAutoService.rejectProposal)(proposalId, comment) },
	// eslint-disable-next-line no-unused-vars
	requestApprovalAutoProposal({ commit }, { proposalId, to, message }) { return call(GopersonalAutoService.requestProposalApproval)(proposalId, { to, message }) },
	// eslint-disable-next-line no-unused-vars
	getAutoActions({ commit }, payload) { return call(GopersonalAutoService.getActions)(payload) },
	// eslint-disable-next-line no-unused-vars
	getAutoActionLevels({ commit }) { return call(GopersonalAutoService.getActionLevels)() },
	// eslint-disable-next-line no-unused-vars
	getAutoAbTests({ commit }, payload) { return call(GopersonalAutoService.getAbTests)(payload) },
	// eslint-disable-next-line no-unused-vars
	getAutoProjectContents({ commit }) { return call(GopersonalAutoService.getProjectContents)() },
	// eslint-disable-next-line no-unused-vars
	getAutoProject({ commit }) { return call(GopersonalAutoService.getProject)() }
}
